(() => {
  const SELECTOR = '[data-da-mmx-root]';

  function initialize(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    if (root.dataset.hideChrome === 'true') document.body.classList.add('da-mmx-hide-chrome');

    root.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-mm-toggle]');
      if (toggle) {
        const target = root.querySelector(toggle.dataset.mmToggle);
        if (target) {
          const opening = target.hasAttribute('hidden');
          target.toggleAttribute('hidden');
          toggle.setAttribute('aria-expanded', String(opening));
          document.body.classList.toggle('da-mmx-lock', opening && target.classList.contains('da-mmx-search'));
          if (opening) target.querySelector('input, a, button')?.focus();
        }
      }

      if (event.target.closest('[data-mm-cookie-accept], [data-mm-cookie-close]')) {
        localStorage.setItem('da_mmx_cookie', 'closed');
        root.querySelector('[data-mm-cookie]')?.setAttribute('hidden', '');
      }
    });

    root.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-mm-quick-add]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button');
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'ADDING…';
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Cart request failed');
        const cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then((result) => result.json());
        root.querySelectorAll('[data-mm-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
        button.textContent = 'ADDED ✓';
        setTimeout(() => { button.disabled = false; button.textContent = original; }, 1300);
      } catch (_) {
        button.disabled = false;
        button.textContent = 'TRY AGAIN';
      }
    });

    if (localStorage.getItem('da_mmx_cookie') === 'closed') root.querySelector('[data-mm-cookie]')?.setAttribute('hidden', '');
  }

  function initializeAll() { document.querySelectorAll(SELECTOR).forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector(SELECTOR)));
  document.addEventListener('shopify:section:unload', () => {
    if (!document.querySelector(SELECTOR)) document.body.classList.remove('da-mmx-hide-chrome', 'da-mmx-lock');
  });
})();
